<template>
  <section>
    <v-container>
      <v-row justify="center">
        <v-col cols="12" xl="8">
          <v-row class="mb-12 align-center" justify="center">
            <!-- image 16:9 -->
            <v-col :order="0" cols="12" sm="6" md="7">
              <v-img
                src="/images/shop/limited-edition.jpeg"
                alt="100ASA Limited Edition Prints"
                aspect-ratio="1.7778"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="5">
              <v-icon large class="mb-6">
                fal fa-tachometer-alt-fast
              </v-icon>
              <h3 class="text-h4 font-weight-bold mb-3">
                Only 100 Prints Per Image
              </h3>
              <p class="text-body-1">
                You will be one of the few to own our exclusive prints. Our
                customers can only buy one print at a time on a first-come,
                first-served basis.
              </p>
            </v-col>
          </v-row>
          <v-row class="mb-12 align-center" justify="center">
            <!-- image 16:9 -->
            <v-col :order="1" cols="12" sm="6" md="7">
              <v-img
                src="/images/shop/artwork.jpeg"
                alt="Test"
                aspect-ratio="1.7778"
              ></v-img>
            </v-col>
            <v-col cols="12" sm="6" md="5">
              <v-icon large class="mb-6">
                fal fa-stars
              </v-icon>
              <h3 class="text-h4 font-weight-bold mb-3">
                Astonishing Artwork
              </h3>
              <p class="text-body-1">
                Your artwork will be printed on premium paper using the latest
                technology. Our team manually handcrafts each print to
                perfection.
              </p>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: 'ShopFeatures'
}
</script>
